// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanEditV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyFloorPlanEditActiveResponseV2WebDto,
  UserPropertyFloorPlanEditActiveV2RequestDto,
  UserPropertyFloorPlanEditDateAvailableResponseV2WebDto,
  UserPropertyFloorPlanEditDateAvailableV2RequestDto,
  UserPropertyFloorPlanEditHighPriceResponseV2WebDto,
  UserPropertyFloorPlanEditHighPriceV2RequestDto,
  UserPropertyFloorPlanEditLowPriceResponseV2WebDto,
  UserPropertyFloorPlanEditLowPriceV2RequestDto,
  UserPropertyFloorPlanEditNameResponseV2WebDto,
  UserPropertyFloorPlanEditNameV2RequestDto,
  UserPropertyFloorPlanEditNumBathroomsResponseV2WebDto,
  UserPropertyFloorPlanEditNumBathroomsV2RequestDto,
  UserPropertyFloorPlanEditNumBedroomsResponseV2WebDto,
  UserPropertyFloorPlanEditNumBedroomsV2RequestDto,
  UserPropertyFloorPlanEditPriceResponseV2WebDto,
  UserPropertyFloorPlanEditPriceV2RequestDto,
  UserPropertyFloorPlanEditSquareFeetResponseV2WebDto,
  UserPropertyFloorPlanEditSquareFeetV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Path =
  '/api/web/v2/users/properties/floorPlans/active';

/**
 * Update activeness of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active = (
  postData: UserPropertyFloorPlanEditActiveV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditActiveV2RequestDto,
    UserPropertyFloorPlanEditActiveResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_active_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Path =
  '/api/web/v2/users/properties/floorPlans/dateAvailable';

/**
 * Update date available of a floor plan, yyyy-MM-dd
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable = (
  postData: UserPropertyFloorPlanEditDateAvailableV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditDateAvailableV2RequestDto,
    UserPropertyFloorPlanEditDateAvailableResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_dateAvailable_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Path =
  '/api/web/v2/users/properties/floorPlans/highPrice';

/**
 * Update the highest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice = (
  postData: UserPropertyFloorPlanEditHighPriceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditHighPriceV2RequestDto,
    UserPropertyFloorPlanEditHighPriceResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_highPrice_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Path =
  '/api/web/v2/users/properties/floorPlans/lowPrice';

/**
 * Update the lowest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice = (
  postData: UserPropertyFloorPlanEditLowPriceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditLowPriceV2RequestDto,
    UserPropertyFloorPlanEditLowPriceResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_lowPrice_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Path =
  '/api/web/v2/users/properties/floorPlans/name';

/**
 * Update name of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name = (
  postData: UserPropertyFloorPlanEditNameV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditNameV2RequestDto,
    UserPropertyFloorPlanEditNameResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_name_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Path =
  '/api/web/v2/users/properties/floorPlans/numBathrooms';

/**
 * Update number of bathrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms = (
  postData: UserPropertyFloorPlanEditNumBathroomsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditNumBathroomsV2RequestDto,
    UserPropertyFloorPlanEditNumBathroomsResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBathrooms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Path =
  '/api/web/v2/users/properties/floorPlans/numBedrooms';

/**
 * Update number of bedrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms = (
  postData: UserPropertyFloorPlanEditNumBedroomsV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditNumBedroomsV2RequestDto,
    UserPropertyFloorPlanEditNumBedroomsResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_numBedrooms_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Path =
  '/api/web/v2/users/properties/floorPlans/price';

/**
 * Update price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price = (
  postData: UserPropertyFloorPlanEditPriceV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditPriceV2RequestDto,
    UserPropertyFloorPlanEditPriceResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_price_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Path =
  '/api/web/v2/users/properties/floorPlans/squareFeet';

/**
 * Update square feet of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet = (
  postData: UserPropertyFloorPlanEditSquareFeetV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyFloorPlanEditSquareFeetV2RequestDto,
    UserPropertyFloorPlanEditSquareFeetResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyFloorPlanEditV2WebApiHandler_squareFeet_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
